import { Link, useLocation } from "react-router-dom";

/** 生活好物父级下的两个子栏目：商城 / 闲置交换 */
export default function GoodsChannelTabs() {
  const { pathname } = useLocation();
  const isSecondhand = pathname.startsWith("/secondhand");

  const tabs = [
    { to: "/shop", label: "商城", active: !isSecondhand },
    { to: "/secondhand", label: "闲置交换", active: isSecondhand },
  ];

  return (
    <div className="flex justify-center gap-2">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`px-5 py-2 rounded-full text-sm font-medium border transition ${
            tab.active
              ? "bg-pink-500 text-white border-pink-500"
              : "bg-white text-gray-600 border-gray-200 hover:border-pink-200"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
}
